// extracted by mini-css-extract-plugin
module.exports = {"Logo":"Rapidoc_Logo__2WvAv"};